var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgComputer = function SvgComputer(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 11,
    "data-width-16": 15,
    "data-width-20": 19,
    "data-width-24": 22,
    "data-width-28": 26,
    viewBox: "0 0 11 9.1",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M9.63.4H1.324a.923.923 0 0 0-.923.923V6.4c0 .51.413.923.923.923h8.308c.51 0 .923-.413.923-.923V1.323A.923.923 0 0 0 9.63.4M3.17 8.708h4.615"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgComputer);
export default ForwardRef;